
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[list]/[slug]",
      function () {
        return require("private-next-pages/[list]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[list]/[slug]"])
      });
    }
  